import React from 'react'
import '../App.css';

function Footer(storeData) {
  return (    
    <>
    {storeData.setStoreData.map((data) => (           
      <div className='footer' key={data.id}>
        {data.storename}. Designed by <a href="http://iamretailer.com/" target="_blank">{data.footertext}</a>
      </div>
      ))
    }  
    </>
  )
}

export default Footer